import { emptyImagePath } from 'Constants/lottiesPaths';

export const SUMMARY_VALUES = {
  jobs_summary_mx: {
    image: emptyImagePath.EMPTY_JOBS,
  },
  investments_summary_mx: {
    image: emptyImagePath.EMPTY_INVESTMENTS,
  },
  deductions_summary_mx: {
    image: emptyImagePath.EMPTY_OTHER_INCOME,
  },
};
